import { SxProps } from '@mui/material'
import { inputDimensions } from '../Input.style'
import { inputClasses } from '../Input.data'

interface InputAdornmentStyles {
  adornment: SxProps
  startAdornment: SxProps
}

export const inputAdornmentStyles: InputAdornmentStyles = {
  adornment: {
    width: inputDimensions.adornmentSize,
    height: inputDimensions.adornmentSize,
    display: 'flex',
    transition: 'all 0.2s',

    [`.${inputClasses.label.placement.inside} &`]: {
      mt: -1.25,

      [`&.${inputClasses.label.shrink}`]: {
        transform: `translate(0, 4px) scale(0.875)`,
      },
    },
  },
  startAdornment: {
    [`.${inputClasses.label.placement.inside} &`]: {
      color: 'text.placeHolder',
    },
  },
}
